var React = require('react');

function TickGreenCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.65 46.3C36.1593 46.3 46.3 36.1593 46.3 23.65C46.3 11.1408 36.1593 1 23.65 1C11.1408 1 1 11.1408 1 23.65C1 36.1593 11.1408 46.3 23.65 46.3Z","fill":"#40A063","stroke":"#40A063","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M15.6475 23.3718L21.4973 29.222L33.0694 17.6499","stroke":"white","strokeWidth":"2.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

TickGreenCircle.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = TickGreenCircle;

TickGreenCircle.default = TickGreenCircle;
